module.exports = __webpack_public_path__ + "6c4a0dbc/img/comments-icon.fdec7fdb.svg";